import { Modal, Form, Input, InputNumber, Checkbox, App } from 'antd';
import { useCreateInvestor } from '@/hooks/useInvestors';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AddInvestorModal({ open, onClose }: Props) {
  const { message } = App.useApp();
  const [form] = Form.useForm<{
    name: string;
    display_order: number;
    active: boolean;
    notes?: string;
  }>();
  const mut = useCreateInvestor();

  async function submit() {
    const v = await form.validateFields();
    try {
      await mut.mutateAsync({
        name: v.name.trim(),
        display_order: v.display_order,
        active: v.active,
        notes: v.notes?.trim() || null,
      });
      message.success('Investor added');
      form.resetFields();
      onClose();
    } catch (e) {
      message.error((e as Error).message);
    }
  }

  return (
    <Modal
      open={open}
      title="Add investor"
      destroyOnHidden
      onCancel={onClose}
      onOk={submit}
      confirmLoading={mut.isPending}
    >
      <Form form={form} layout="vertical" initialValues={{ display_order: 99, active: true }}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input autoFocus placeholder="Athena" />
        </Form.Item>
        <Form.Item label="Display order" name="display_order">
          <InputNumber min={0} max={9999} />
        </Form.Item>
        <Form.Item name="active" valuePropName="checked">
          <Checkbox>Active (visible in iOS filter)</Checkbox>
        </Form.Item>
        <Form.Item label="Notes" name="notes">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
